import { ObservableArray, View, ViewModel } from "binder"
import { propertyTypes, TypeSelectorViewModel } from "./typeSelector-viewModel"

export class TypeSelectorView extends View<TypeSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-39741CAC-8EC2-4A9D-94A8-C10040193012"
    }
    loadHtml(): string {
        let element = require('./typeSelector.html').default;
        let style = require('./typeSelector.less');
        return element;
    }
    constructor() {
       super();
    }

    public set validTypes(v: ObservableArray<propertyTypes>) { this._validTypes = v; } public get validTypes(): ObservableArray<propertyTypes> { return this._validTypes;} private _validTypes: ObservableArray<propertyTypes>;
    public set selectedType(v: propertyTypes) { this._selectedType = v; } public get selectedType(): propertyTypes { return this._selectedType;} private _selectedType: propertyTypes;
    public set genericTypeSelector(v: ViewModel) { this._genericTypeSelector = v; } public get genericTypeSelector(): ViewModel { return this._genericTypeSelector;} private _genericTypeSelector: ViewModel;

}
